var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData)?_c('div',[_c('div',{staticStyle:{"width":"1680px","height":"558px"},attrs:{"id":"enterprise-forecast"}})]):_c('div',[_c('div',{staticStyle:{"line-height":"500px"}},[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }